import ManualSVG from '@/assets/icons/manual.svg';
import SoftwareSVG from '@/assets/icons/software.svg';
import SupportSVG from '@/assets/icons/support.svg';
import ArrowSVG from '@/assets/icons/arrow.svg';

export default {
  name: 'RelatedCard',
  data() {
    return {
      className: 'app__related__card',
    };
  },
  computed: {
    imageClassName() {
      return `${this.className}__image`;
    },
    titleClassName() {
      return `${this.className}__title`;
    },
    titleTextClassName() {
      return `${this.className}__title__text`;
    },
    innerClassName() {
      return `${this.className}__inner`;
    },
    arrowClassName() {
      return `${this.titleClassName}__arrow`;
    },
    hasIconClassName() {
      return this.iconType.length ? `${this.className}--has-icon` : '';
    },
    svgComponent() {
      switch (this.iconType) {
        case 'manual':
          return ManualSVG;
        case 'software':
          return SoftwareSVG;
        case 'support':
          return SupportSVG;
        default:
          return null;
      }
    },
  },
  props: {
    link: {
      type: String,
      default: '',
    },
    iconType: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  components: {
    ManualSVG,
    SoftwareSVG,
    SupportSVG,
    ArrowSVG,
  },
};
